"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initReadyChecks = exports.initFooterPreload = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
const pako_1 = __importDefault(require("pako"));
const defaultEpicGamesFooter = {};
const initFooterPreload = () => {
    if (!window_or_global_1.default._epicGamesFooter) {
        window_or_global_1.default._epicGamesFooter = defaultEpicGamesFooter;
    }
    if (window_or_global_1.default.__server_side_render)
        return;
    if (typeof window_or_global_1.default._epicGamesFooter === 'string' && /^([0-9]+),/.test(window_or_global_1.default._epicGamesFooter)) {
        // EpicGamesFooter is pako encoded.
        try {
            const preload = JSON.parse(pako_1.default.inflate(window_or_global_1.default._epicGamesFooter.split(','), { to: 'string' }));
            window_or_global_1.default._epicGamesFooter = preload;
        }
        catch (error) {
            // Ignore.
            window_or_global_1.default._epicGamesFooter = defaultEpicGamesFooter;
        }
    }
};
exports.initFooterPreload = initFooterPreload;
const initReadyChecks = () => {
    //allow external sites to apply logic when the footer is rendered
    if (typeof window_or_global_1.default._egFooterReadyCallback === 'function') {
        window_or_global_1.default._egFooterReadyCallback();
        window_or_global_1.default._egFooterReadyCallbackRun = true;
    }
    else {
        //start loop in case callback is created late
        let readyChecks = 0;
        const readyCheck = setInterval(() => {
            try {
                readyChecks += 1;
                if (window_or_global_1.default && window_or_global_1.default._egFooterReadyCallback && typeof window_or_global_1.default._egFooterReadyCallback === 'function') {
                    window_or_global_1.default._egFooterReadyCallback();
                    window_or_global_1.default._egFooterReadyCallbackRun = true;
                    clearInterval(readyCheck);
                }
                if (readyChecks > 10) {
                    clearInterval(readyCheck);
                }
            }
            catch (e) {
                clearInterval(readyCheck);
            }
        }, 500);
    }
    window_or_global_1.default._egFooterReadyCallbackCalled = true;
};
exports.initReadyChecks = initReadyChecks;
//# sourceMappingURL=globalFooterUtils.js.map